import React from 'react';

import { Color, HealthListStyled } from './styled';

import clsx from 'clsx';
import healthList from 'src/apis/samples/health';

interface HeallthListProps {
  className?: string;
}

const HealthList = ({ className }: HeallthListProps) => {
  return (
    <HealthListStyled className={clsx('HeallthList', className)}>
      <h1 className="listTitle">운동 리스트</h1>
      <div className="list">
        {healthList.map(health => (
          <div className="listItem" key={health.id}>
            <div className="left">
              <div className="image">
                <img src={health.image} alt={health.title} />
              </div>
            </div>
            <div className="right">
              <div className="title">
                <Color color={health.color} />
                {health.title}
              </div>
              <div className="description">{health.shortDescription}</div>
            </div>
          </div>
        ))}
      </div>
    </HealthListStyled>
  );
};

export default React.memo(HealthList);
